(function () {
  function perView() {
    if (window.innerWidth >= 1024) return 3;
    if (window.innerWidth >= 768) return 2;
    return 1;
  }

  function init() {
    var root = document.querySelector('.rnc-reviews-container .swiper');
    if (!root || root.dataset.rncReviewsInit === 'vanilla') return;
    if (root.swiper) return;

    var wrapper = root.querySelector('.swiper-wrapper');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.swiper-slide'));
    var prev = document.querySelector('.rnc-reviews-nav-prev');
    var next = document.querySelector('.rnc-reviews-nav-next');
    var pagination = document.querySelector('.rnc-reviews-pagination');
    if (!wrapper || !slides.length || !prev || !next) return;

    root.dataset.rncReviewsInit = 'vanilla';
    var index = 0;

    function maxIndex() {
      return Math.max(0, slides.length - perView());
    }

    function paint() {
      var view = perView();
      if (index > maxIndex()) index = 0;
      if (index < 0) index = maxIndex();

      slides.forEach(function (slide) {
        var basis = 100 / view + '%';
        slide.style.boxSizing = 'border-box';
        slide.style.flex = '0 0 ' + basis;
        slide.style.width = basis;
        slide.style.maxWidth = basis;
        slide.style.paddingLeft = view > 1 ? '12px' : '0';
        slide.style.paddingRight = view > 1 ? '12px' : '0';
      });

      wrapper.style.transform = 'translate3d(' + -index * (100 / view) + '%, 0, 0)';
      prev.setAttribute('aria-disabled', 'false');
      next.setAttribute('aria-disabled', 'false');

      if (pagination) {
        var pages = maxIndex() + 1;
        if (pagination.childElementCount !== pages) {
          pagination.innerHTML = '';
          for (var i = 0; i < pages; i++) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'swiper-pagination-bullet';
            dot.setAttribute('aria-label', 'Show review ' + (i + 1));
            dot.addEventListener('click', function (event) {
              index = Number(event.currentTarget.getAttribute('data-index'));
              paint();
            });
            dot.setAttribute('data-index', String(i));
            pagination.appendChild(dot);
          }
        }
        Array.prototype.forEach.call(pagination.children, function (dot, i) {
          var on = i === index;
          dot.classList.toggle('swiper-pagination-bullet-active', on);
          dot.setAttribute('aria-current', on ? 'true' : 'false');
        });
      }
    }

    function move(delta) {
      var pages = maxIndex() + 1;
      index = (index + delta + pages) % pages;
      paint();
    }

    prev.addEventListener('click', function () {
      move(-1);
    });
    next.addEventListener('click', function () {
      move(1);
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(paint, 100);
    });

    paint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
